import { Injectable } from '@angular/core';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import { NewLmsCoursePayload } from '../../types/payloads/lms-course.payloads';

@Injectable({
  providedIn: 'root',
})
export class LmsCourseListService {
  constructor(private apiService: APICoreService) {}

  getCourses(
    districtId?: number,
    pageSize = 10,
    page?: number,
    status?: string,
    search?: string
  ) {
    const params: {
      district_id?: number;
      per_page: number;
      page?: number;
      status?: string;
      expand: string;
      search?: string;
    } = {
      per_page: pageSize,
      expand: 'registrationCount,district,sessionCount',
    };

    if (districtId !== undefined) {
      params.district_id = districtId;
    }

    if (page !== undefined) {
      params.page = page;
    }

    if (status) {
      params.status = status;
    }

    if (search) {
      params.search = search;
    }

    return this.apiService.getRequest('lms-course', params);
  }

  createLmsCourse(payload: NewLmsCoursePayload) {
    return this.apiService.postRequest('lms-course', payload);
  }
}
